import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { ContentPreview } from './components/ContentPreview';
import { ProductShowcase } from './components/ProductShowcase';
import { CountdownTimer } from './components/CountdownTimer';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { OrderSummary } from './components/OrderSummary';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FeaturesDetail } from './components/FeaturesDetail';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
      (window as any).fbq('init', '1447298077020597');
      (window as any).fbq('track', 'PageView');
    }
    // noscript fallback pixel
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1447298077020597&ev=PageView&noscript=1';
    document.body.appendChild(img);
    return () => {
      if (img.parentNode) img.parentNode.removeChild(img);
    };
  }, []);
  return <div className="min-h-screen bg-cream font-body text-navy-900 selection:bg-gold selection:text-navy-900" data-id="element-0">
      <StickyAlertBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Benefits data-id="element-5" />
        <ContentPreview data-id="element-6" />
        <ProductShowcase data-id="element-7" />
        <CountdownTimer data-id="element-8" />
        <BonusSection data-id="element-9" />
        <Testimonials data-id="element-10" />
        <OrderSummary data-id="element-11" />
        <Guarantee data-id="element-12" />
        <FAQ data-id="element-13" />
        <FeaturesDetail data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}